export function changeDateFormat(date:string|Date,format:string){

    if(!date.toString().trim())
        return "";

    date = new Date(date);
    var dd = date.getDate().toString();
    var mm = (date.getMonth() + 1).toString();
    var yyyy = date.getFullYear().toString();
    var yy = date.getFullYear().toString().slice(2,);

    if (parseInt(dd) < 10)
        dd = '0' + dd
    if (parseInt(mm) < 10)
        mm = '0' + mm

    if(format=="yyyy-mm-dd")
        return yyyy + '-' + mm + '-' + dd;
    else if(format=="yy-mm-dd")
        return yy + '-' + mm + '-' + dd;
    else if(format=="yyyy/mm/dd")
        return yyyy + '/' + mm + '/' + dd;
    else if(format=="yy/mm/dd")
        return yy + '/' + mm + '/' + dd;

    else if(format=="mm-dd-yyyy")
        return mm + '-' + dd + '-' + yyyy;
    else if(format=="mm-dd-yy")
        return mm + '-' + dd + '-' + yy;
    else if(format=="mm/dd/yyyy")
        return mm + '/' + dd + '/' + yyyy;
    else if(format=="mm/dd/yy")
        return mm + '/' + dd + '/' + yy;

    else if(format=="dd-mm-yyyy")
        return dd + '-' + mm + '-' + yyyy;
    else if(format=="dd/mm/yyyy")
        return dd + '/' + mm + '/' + yyyy;
    else if(format=="dd-mm-yy")
        return dd + '-' + mm + '-' + yy;
    else if(format=="dd/mm/yy")
        return dd + '/' + mm + '/' + yy;
    
    return "";
}

//parameter date format should be "yyyy-mm-dd*"
export function changeDateFormatJavaToUi(date:string|Date,format:string){
    
    if(!date || date.toString().trim()=='')
        return "";
    
    date=date.toString().trim();
    var dd = date.slice(8,10);
    var mm = date.slice(5, 7);
    var yyyy = date.slice(0,4);
    var yy = date.slice(2,4);

    if(format=="yyyy-mm-dd")
        return yyyy + '-' + mm + '-' + dd;
    else if(format=="yy-mm-dd")
        return yy + '-' + mm + '-' + dd;
    else if(format=="yyyy/mm/dd")
        return yyyy + '/' + mm + '/' + dd;
    else if(format=="yy/mm/dd")
        return yy + '/' + mm + '/' + dd;

    else if(format=="mm-dd-yyyy")
        return mm + '-' + dd + '-' + yyyy;
    else if(format=="mm-dd-yy")
        return mm + '-' + dd + '-' + yy;
    else if(format=="mm/dd/yyyy")
        return mm + '/' + dd + '/' + yyyy;
    else if(format=="mm/dd/yy")
        return mm + '/' + dd + '/' + yy;

    else if(format=="dd-mm-yyyy")
        return dd + '-' + mm + '-' + yyyy;
    else if(format=="dd/mm/yyyy")
        return dd + '/' + mm + '/' + yyyy;
    else if(format=="dd-mm-yy")
        return dd + '-' + mm + '-' + yy;
    else if(format=="dd/mm/yy")
        return dd + '/' + mm + '/' + yy;
    
    return "";
}

export function getDayDiff(startDate: Date|string, endDate: Date|string): number {
    startDate = new Date(changeDateFormatJavaToUi(startDate,'yyyy/mm/dd'));
    endDate = new Date(changeDateFormatJavaToUi(endDate,'yyyy/mm/dd'));
    
    const msInDay = 24 * 60 * 60 * 1000;
    
    return ((Number(startDate) - Number(endDate)) / msInDay);
}

export function getWeekDays(startDate: Date|string, endDate: Date|string): number {
    startDate = new Date(startDate);
    endDate = new Date(endDate);

    let isReversed=false;

    if(startDate.getTime()>endDate.getTime()){
        isReversed=true;
        let temp=endDate;
        endDate=startDate;
        startDate=temp;
    }
    
    const msInDay = 24 * 60 * 60 * 1000;
    
    //total number of days
    let noOfDays = (Number(endDate)- Number(startDate)) / msInDay;

    // Subtract two weekend days for every week in between
    var weeks = Math.floor(noOfDays / 7);
    if(noOfDays>6)
        noOfDays -= weeks * 2;

    let startDateDay = startDate.getDay();
    let endDateDay = endDate.getDay();

    // Remove weekend not previously removed.   
    if (startDateDay - endDateDay > 1 && noOfDays) {
        noOfDays -= 2;
    }
    // Remove start day if span starts on Sunday but ends before Saturday
    if (startDateDay == 0 && endDateDay != 6 && noOfDays && !isReversed) {
        noOfDays-=1;  
    }
    // Remove end day if span ends on Saturday but starts after Sunday
    else if (endDateDay == 6 && startDateDay != 0 && noOfDays && isReversed) {
        noOfDays-=1;  
    }

    //Exclue endDate
    // if(endDateDay<6 && endDateDay>0)
    //     noOfDays-=1;
    if(isReversed)
        return -noOfDays;

    return noOfDays;

}